/* RESPONSIBLE TEAM: team-knowledge-foundations */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';

export default class Setting extends EmbercomBaseSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    category: { embedded: 'always' },
    copies: { embedded: 'always' },
  };
}
